import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=28c6b1c7&scoped=true"
import script from "./Layer.vue?vue&type=script&lang=js"
export * from "./Layer.vue?vue&type=script&lang=js"
import style0 from "./Layer.vue?vue&type=style&index=0&id=28c6b1c7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6b1c7",
  null
  
)

export default component.exports